import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';
import '../../common/bn-surface';
import '../../common/bn-flash';
import '../device-show';

class DeviceShowModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'device-show-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#device-show-modal {
          --modal-min-width: 50%;
          --modal-max-width: 90%;
        }
      </style>

      <h3 slot="title">Edit Device</h3>
      <device-show .href="${this.href}" hidetitle></device-show>
    `;
  }
}

window.customElements.define('device-show-modal', DeviceShowModal);
